import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BubbleDirective, aosColor as colors, IconComponent, StatusDotComponent, TableColumn } from '@ui/aos-lib';
import { UpdateType } from '../../services/history-api.types';
import { notAvailable } from 'src/app/shared/constants';
import { AlarmStatus, HistoryUpdateData } from '../../services/history-data.types';
import { isArray } from 'src/app/shared/utils';

@Component({
  templateUrl: 'history-values.component.html',
  styleUrls: ['history-values.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BubbleDirective, IconComponent, NgTemplateOutlet, StatusDotComponent]
})
export class HistoryValuesComponent {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() item!: any;
  @Input() column!: TableColumn;

  protected readonly iconName = 'arrow_forward';
  protected readonly notAvailable = notAvailable;
  protected readonly UpdateType = UpdateType;
  protected readonly AlarmStatus = AlarmStatus;
  protected readonly arrowColor = colors.primary400;

  protected isArray(value: HistoryUpdateData): boolean {
    return isArray<HistoryUpdateData>(value);
  }
}
